//@flow

import { Link } from "gatsby";
import React from "react";

type Props = {
    heading: {
        path?: string,
        content: string,
    },
    children?: React$Node,
};

const FooterSection = (props: Props): React$Element<"div"> => (
    <div className="footer-section">
        <header className={"line-height-xs mb-3"}>
            <strong>
                {props.heading.path ? (
                    <Link to={props.heading.path}>
                        {props.heading.content}
                    </Link>
                ) : (
                    <>{props.heading.content}</>
                )}
            </strong>
        </header>
        {props.children}
    </div>
);

export default FooterSection;
